import React, { useState, useEffect, useRef } from "react";
import "./App.css";
// Layout
import Navbar from "./components/layout/Navbar";
import { SimpleFooter } from "./components/layout/Footer";

// Pages
import HomePage from "./components/pages/HomePage";
import AboutUsPage from "./components/pages/AboutUsPage";
import ClientsPage from "./components/pages/ClientsPage";
import EventsAwardsPage from "./components/pages/EventsAwardsPage";
import ContactPage from "./components/pages/ContactPage";

// Products
import ProductsLandingPage from "./components/products/ProductsLandingPage";
import SoftwareProductsPage from "./components/products/SoftwareProductsPage";
import HardwareProductsPage from "./components/products/HardwareProductsPage";
import MapsDataProductsPage from "./components/products/MapsDataProductsPage";
import HereMapsPage from "./components/products/HereMapsPage";
// Industries
import ServicesLandingPage from "./components/industries/ServicesLandingPage";
import InformationTechnologyPage from "./components/industries/InformationTechnologyPage";
import GISDataServicesPage from "./components/industries/GISDataServicesPage";
import AgriculturePage from "./components/industries/AgriculturePage";
import EnvironmentPage from "./components/industries/EnvironmentPage";
import HealthPage from "./components/industries/HealthPage";
import EducationResearchPage from "./components/industries/EducationResearchPage";
import TrainingServicesPage from "./components/pages/TrainingServicesPage";
import AttendanceSystemPage from "./components/pages/AttendanceSystemPage";



// Main App component with conditional rendering
export default function App() {
  const [activePage, setActivePage] = useState("home");
  
  // Handle browser back/forward buttons
  useEffect(() => {
    const handlePopState = (event) => {
      // Get page from history state
      const page = event.state?.page || 'home';
      setActivePage(page);
      window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Listen for browser back/forward button
    window.addEventListener('popstate', handlePopState);

    // Set initial history state
    if (!window.history.state?.page) {
      window.history.replaceState({ page: 'home' }, '', window.location.pathname);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  const handleNavClick = (page) => {
    setActivePage(page);
    // Add to browser history without changing URL
    window.history.pushState({ page: page }, '', window.location.pathname);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const renderPage = () => {
    switch (activePage) {
      case "aboutus":
        return <AboutUsPage />;
      case "products-landing":
        return <ProductsLandingPage handleNavClick={handleNavClick} />;
      case "software-products":
        return <SoftwareProductsPage handleNavClick={handleNavClick} />;
      case "hardware-products":
        return <HardwareProductsPage handleNavClick={handleNavClick} />;
      case "maps-data-products":
        return <MapsDataProductsPage handleNavClick={handleNavClick} />;
      case "heremaps":
        return <HereMapsPage handleNavClick={handleNavClick} />;
      case "clients":
        return <ClientsPage handleNavClick={handleNavClick} />;
      case "services-landing":
        return <ServicesLandingPage handleNavClick={handleNavClick} />;
      case "information-technology":
        return <InformationTechnologyPage handleNavClick={handleNavClick} />;
      case "gis-services":
        return <GISDataServicesPage handleNavClick={handleNavClick} />;
      case "agriculture":
        return <AgriculturePage handleNavClick={handleNavClick} />;
      case "environment":
        return <EnvironmentPage handleNavClick={handleNavClick} />;
      case "health":
        return <HealthPage handleNavClick={handleNavClick} />;
      case "education-research":
        return <EducationResearchPage handleNavClick={handleNavClick} />;
      case "training-services":
        return <TrainingServicesPage handleNavClick={handleNavClick} />;
      case "events-awards":
        return <EventsAwardsPage />;
      case "attendancemanagementsystem":
        return <AttendanceSystemPage />;
      case "contactus":
        return <ContactPage />;
      case "home":
      default:
        return <HomePage handleNavClick={handleNavClick} />;
    }
  };

  return (
    <div className="App">
      <Navbar handleNavClick={handleNavClick} activePage={activePage} />
      <main>{renderPage()}</main>
      {activePage !== "home" && (
        <SimpleFooter handleNavClick={handleNavClick} />
      )}
    </div>
  );
}